import { useEffect } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import SignInPage from "./components/auth/SignInPage";
import HomePage from "./components/dashboard/HomePage";
import DiamondPage from "./components/diamond/DiamondPage";
import LoadingIndicator from "./components/layouts/LoadingIndicator";
import Navbar from "./components/layouts/Navbar";
import ProfilePage from "./components/settings/ProfilePage";
import { checkAuthentication } from "./redux/auth/authActions";
import './default.css';
import CreateDiamondPage from "./components/diamond/CreateDiamondPage";
import TopupPage from "./components/topup/TopupPage";
import MessengerPage from "./components/messenger/MessengerPage";
import ChatRoom from "./components/messenger/ChatRoom";
import UserPage from "./components/settings/UserPage";
import AdminPage from "./components/settings/AdminPage";
import { Toaster } from "react-hot-toast";
import PaymentSettingPage from "./components/settings/PaymentSettingPage";
import EditDiamondPage from "./components/diamond/EditDiamondPage";
import TopupDetails from "./components/topup/TopupDetails";
import DemoPage from "./components/Demopage";

const ProtectedRoute = ({ component: Component, auth, ...restOfProps }) => {
    return (
        <Route
          {...restOfProps}
          render={(props) =>
            (auth.user !== null) ? <Component {...props} /> : <Redirect to="/signin" />
          }
        />
    );
}

const ProtectedAdminRoute = ({ component: Component, auth, ...restOfProps }) => {
    return (
        <Route
          {...restOfProps}
          render={(props) =>
            (auth.user !== null &&( auth.user.type === 'admin' ||  auth.user.type === 'super-admin')) ? <Component {...props} /> : <Redirect to="/" />
          }
        />
    );
}

const ProtectedSuperAdminRoute = ({ component: Component, auth, ...restOfProps }) => {
    return (
        <Route
          {...restOfProps}
          render={(props) =>
            (auth.user !== null && auth.user.type === 'super-admin') ? <Component {...props} /> : <Redirect to="/" />
          }
        />
    );
}

const App = ({ auth, checkAuthentication }) => {
    
    useEffect(() => {
        // checkAuthentication();
    }, []);

    // return (<LoadingIndicator customClass={'h-screen'} />);

    return auth.loading ? (<LoadingIndicator customClass={'h-screen'} />) : (
        <BrowserRouter>
            <div className="mb-14 pb-3">
                <Switch>
                    <Route auth={auth} path="/demo" component={DemoPage}/>
                    <Route auth={auth} path="/signin" component={SignInPage}/>
                    <ProtectedRoute auth={auth} exact path="/" component={HomePage}/>
                    <ProtectedAdminRoute auth={auth} path="/diamonds" component={DiamondPage}/>
                    <ProtectedAdminRoute auth={auth} path="/create-diamond" component={CreateDiamondPage}/>
                    <ProtectedAdminRoute exact auth={auth} path="/topup" component={TopupPage}/>
                    <ProtectedAdminRoute auth={auth} path="/topup/:id" component={TopupDetails}/>
                    <ProtectedAdminRoute auth={auth} path="/settings" component={ProfilePage}/>
                    <ProtectedAdminRoute auth={auth} path="/messages" component={MessengerPage}/>
                    <ProtectedAdminRoute auth={auth} path="/chat-room" component={ChatRoom}/>
                    <ProtectedAdminRoute auth={auth} path="/users" component={UserPage}/>
                    <ProtectedAdminRoute auth={auth} path="/edit-diamond-card" component={EditDiamondPage}/>
                    <ProtectedSuperAdminRoute auth={auth} path="/admins" component={AdminPage}/>
                    <ProtectedSuperAdminRoute auth={auth} path="/payment-settings" component={PaymentSettingPage}/>
                    {/* <Route path="/shop">
                        <ShopPage/>
                    </Route>
                    <Route path="/cart">
                        <CartPage/>
                    </Route>
                    <Route path="/checkout">Checkout</Route>
                    <Route path="/account">Account</Route>
                    <Route path="/orders">Orders</Route>
                    <Route path="/about">
                        <AboutPage/>
                    </Route>
                    <Route exact path="/product/:id">
                        <ProductDetailsPage/>
                    </Route> */}
                </Switch>
                <Navbar/>
            </div>
            <Toaster toastOptions={{className:'backdrop-filter backdrop-blur-lg bg-opacity-20'}}/>
        </BrowserRouter>
    );
}

const mapStateToProps = state => {
    return {
        auth: state.auth
    };
}


const mapDispatchToProps = dispatch => {
    return {
        checkAuthentication: () => dispatch(checkAuthentication()),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
